"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_redux_1 = require("react-redux");
var PopupForm_1 = __importStar(require("../../../common/PopupForm"));
var authenticity_token_1 = require("../../ducks/authenticity-token");
var product_1 = require("../../ducks/product");
var withErrorBoundary_1 = __importDefault(require("../../../../decorators/withErrorBoundary"));
var OneClickContainer = function (_a) {
    var modalIsOpen = _a.modalIsOpen, setModalIsOpen = _a.setModalIsOpen;
    var product = (0, react_redux_1.useSelector)(product_1.productSelector);
    var authenticityToken = (0, react_redux_1.useSelector)(authenticity_token_1.authenticityTokenSelector);
    var thankYouPage = function () {
        setTimeout(function () {
            location.pathname = '/thank_you';
        }, 700);
    };
    return (react_1.default.createElement(PopupForm_1.default, { authToken: authenticityToken, open: modalIsOpen, onClose: function () { return setModalIsOpen(false); }, onSubmit: thankYouPage, productId: product.id.toString(), formName: PopupForm_1.BUY_ONECLICK_FORM, requestName: "/one_click_orders", title: "\u041A\u0443\u043F\u0438\u0442\u044C \u0432 1 \u043A\u043B\u0438\u043A", btnTitle: "\u041E\u0424\u041E\u0420\u041C\u0418\u0422\u042C \u0417\u0410\u041A\u0410\u0417" }));
};
exports.default = (0, withErrorBoundary_1.default)(OneClickContainer);
